
bq.global.select2Setup = function() {
  $('select.select2').each(function() {
    $(this).select2({
        // placeholder: '-- Please Select --',
        allowClear: true
    });
    $(this).trigger($.Event('bq.global.select2Setup.after'));
  });

    // catch when any select2 is open
    $(document).on('select2-opening', function(){
        // hide all opened datepickers
        $('body > .datepicker.datepicker-dropdown').hide();
    });

    // reset select2 when reset button is pressed
    $('button[type="reset"]').on('click',function(){
        var form = $(this).parents('form:first');
        if (form.find('.select2')){
            form.find('.select2').select2('val','');
        }
    })
};

bq.init.push(bq.global.select2Setup);
